<template>
  <v-flex xs12 pt-4>
    <v-card>
      <v-toolbar
        light
        color="white"
        class="elevation-2"
      >
        <v-toolbar-title>Dashboard</v-toolbar-title>
      </v-toolbar>
      <v-container grid-list-md fluid>
        <v-layout row wrap fill-height>

          <InfoWidget
            title="Wykorzystane miejsce"
            :main-value="spaceUsedPercent"
          >
            <div class="box-inner__chart d-flex align-center">
              <v-progress-circular
                :size="120"
                :width="10"
                :value="spaceUsedPercent"
                color="primary"
              >
                <span class="display-1">{{ spaceUsedPercent }}%</span>
              </v-progress-circular>
            </div>
            <div class="box-inner__desc d-flex align-center mb-2">
              {{spaceUsed}} z {{spaceAvailable}}
            </div>
          </InfoWidget>

          <InfoWidget
            title="Data wygaśnięcia"
            :main-value="subscriptionExpirationDay"
          >
            <div class="box-inner__icon d-flex align-center">
              <v-icon color="primary" :size="36">fas fa-calendar-alt</v-icon>
            </div>
            <div class="box-inner__title primary--text display-1 d-flex align-center">
              {{subscriptionExpirationDay}}
            </div>
            <div class="box-inner__desc text-uppercase d-flex align-center mb-2">
              {{subscriptionExpirationMonth}}<br/>{{subscriptionExpirationYear}}
            </div>
          </InfoWidget>

          <InfoWidget
            title="Liczba plików"
            :main-value="filesCount"
          >
            <div class="box-inner__icon d-flex align-center">
              <v-icon color="primary" :size="36">fas fa-file</v-icon>
            </div>
            <div class="box-inner__title primary--text display-1 d-flex align-center">
              {{filesCount}}
            </div>
            <div class="box-inner__desc text-uppercase d-flex align-center mb-2">
              <span v-text="plural(filesCount, ['Plik', 'Pliki', 'Plików'])"></span>
            </div>
          </InfoWidget>

          <InfoWidget
            title="Liczba folderów"
            :main-value="directoriesCount"
          >
            <div class="box-inner__icon d-flex align-center">
              <v-icon color="primary" :size="36">folder</v-icon>
            </div>
            <div class="box-inner__title primary--text display-1 d-flex align-center">
              {{directoriesCount}}
            </div>
            <div class="box-inner__desc text-uppercase d-flex align-center mb-2">
              <span v-text="plural(directoriesCount, ['Folder', 'Foldery', 'Folderów'])"></span>
            </div>
          </InfoWidget>

        </v-layout>
      </v-container>
    </v-card>
    <AccountExpiration/>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import cookies from 'js-cookie';
import InfoWidget from './InfoWidget.vue';
import AccountExpiration from './Dialogs/AccountExpiration.vue';
import { getPlural } from '../../helpers/helpers';
import config from '../../config';

export default {
  name: 'dashboard-client',
  components: {
    InfoWidget,
    AccountExpiration,
  },
  computed: {
    ...mapGetters('dashboard-client', [
      'spaceUsed',
      'spaceAvailable',
      'spaceUsedPercent',
      'subscriptionExpirationDate',
      'subscriptionExpirationDay',
      'subscriptionExpirationYear',
      'subscriptionExpirationMonth',
      'daysToExpire',
      'filesCount',
      'directoriesCount',
    ]),
  },
  watch: {
    daysToExpire(val) {
      if (val && val > 0) {
        this.checkAccounExpiration();
      }
    },
  },
  methods: {
    ...mapActions('dashboard-client', [
      'getClientData',
      'setDialogVisbility',
    ]),
    plural(number, phrases) {
      return getPlural(number, phrases);
    },
    getData() {
      this.getClientData();
    },
    checkAccounExpiration() {
      if (this.daysToExpire > config.accountExpirationNotifyDays) {
        return;
      }
      if (cookies.get('accounExpirationPopup') !== undefined) {
        return;
      }
      const date = new Date();
      const midnight = new Date(date.setHours(23, 59, 59, 0));
      cookies.set('accounExpirationPopup', '1', { expires: midnight });
      this.setDialogVisbility('account-expiration');
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
  .box-inner__chart{
    min-height: 130px;
  }
  .box-inner__icon{
    min-height: 70px;
  }
  .box-inner__title{
    min-height: 60px;
  }
  .box-inner__desc{
    min-height: 50px;
  }
</style>
